import {Component, Input} from '@angular/core';
import {AppState} from 'src/app/app.reducer';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import * as actions from 'src/app/data/actions/notifications.actions';

@Component({
  selector: 'app-notification-indicator',
  templateUrl: './notification-indicator.component.html',
  styleUrls: ['./notification-indicator.component.scss']
})
export class NotificationIndicatorComponent {

  newCards = 0;
  @Input() iconSize = '2.5rem';
  @Input() notificacionIcon;
  @Input() iconColor = '#418fde';
  @Input() indicatorColor = {
    background: '#d00000',
    color: 'white'
  };
  
  constructor(
    private router: Router,
    private store: Store<AppState>
  ) {}

  ngAfterViewInit() {
    this.store.select('notificationState').subscribe(
      (state) => this.newCards = state.newCards
    );
  }

  get iconStyle() {
    return {
      height: '2.7rem',
      width: this.iconSize
    };
  }

  get indicatorStyle() {
    return { 
      color: this.indicatorColor.color,
      'background-color': this.indicatorColor.background
    };
  }

  openNotifications() {
    this.store.dispatch(actions.allViewed());
    this.router.navigate(['/cuenta/notificaciones/listado']);
  }

}